var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("用户列表")]),_c('el-table',{staticStyle:{"width":"100%","margin-top":"20px"},attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","width":"80"}}),_c('el-table-column',{attrs:{"prop":"title","label":"标题"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }